export const CLASSES_NOT_STARTED_MESSAGE = 'No Classes Created'
export const NOT_STARTED_MESSAGE = 'with no lessons done'
export const DWB_LESSONS_COMPLETED_LABEL = ' of Lessons Completed'
export const TRAINING_PROGRESS_REPORT_LABEL = 'Training Progress Report'
